module.exports = function () {
    $(document).ready(function () {

	    var AjaxController = require('./services/AjaxController');

        var modalCategory   = $('#edit-expenditures-category');
        var modalType       = $('#edit-expenditures-type');

        /** Register tree view a click event */
        $('#js-expenditure-jstree a[data-toggle="modal"]').on('click', function() {

            var whatClicked     = $(this).data('what'),
		            whatCategoryId  = $(this).data('category'),
		            name         = $(this).data('name'),
		            specialProfitAndLoss = $(this).data('profit-and-loss');

            if (whatClicked == 'category') {

                modalCategory.find('#category_inputCategoryId').val(whatCategoryId);
                modalCategory.find('#category_inputName').val(name);
	            modalCategory.find('[name=special_profit_and_loss][value=' + specialProfitAndLoss + ']').prop("checked", true)

            } else if (whatClicked == 'type') {

                var whatTypeId = $(this).data('type');

                modalType.find('#type_inputCategoryId').val(whatCategoryId);
                modalType.find('#type_inputTypeId').val(whatTypeId);
                modalType.find('#type_inputName').val(name);
            }

        });

	    $('.expenditure-to-delete').on('click', function() {
	    	var $this = $(this);
		    window.location.href = $this.attr('href');
	    });

    });
}();